import { registerSW } from "virtual:pwa-register";

/**
 * ลงทะเบียน service worker เฉพาะ production (cache app shell เท่านั้น ไม่ cache API)
 * รอให้หน้าโหลดเสร็จและเบราว์เซอร์ว่างก่อน เพื่อไม่แย่งแบนด์วิดท์และ CPU กับการแสดงผลครั้งแรก
 */
export function registerPwa(): void {
  if (!import.meta.env.PROD) return;
  const start = () => registerSW({ immediate: true });
  const later = () => {
    if (typeof window.requestIdleCallback === "function") window.requestIdleCallback(start, { timeout: 4000 });
    else window.setTimeout(start, 1500);
  };
  if (document.readyState === "complete") later();
  else window.addEventListener("load", later, { once: true });
}
